// removed by extract-text-webpack-plugin
module.exports = {"container":"PastMeetingDetails-container","tabsContainer":"PastMeetingDetails-tabsContainer","flexCol":"PastMeetingDetails-flexCol","separator":"PastMeetingDetails-separator"};